const internationalSampleCsvData = [
  {
    type: 'PERSONAL',
    countryCode: 'US',
    accountDetailsType: 'ACCOUNT_ID',
    accountDetailsValue: '781245633',
    bankIdentifierType: 'CLEARING_ID',
    bankIdentifierValue: '101000019',
    givenName: 'MELANIE',
    surname: 'DANIELS',
  },
  {
    type: 'PERSONAL',
    countryCode: 'PK',
    accountDetailsType: 'IBAN',
    accountDetailsValue: 'PK35HABB0001111222212345',
    bankIdentifierType: 'BIC',
    bankIdentifierValue: 'HABBPKKA',
    fullName: 'KAMALA KHAN',
  },
  {
    type: 'PERSONAL',
    countryCode: 'ID',
    accountDetailsType: 'ACCOUNT_ID',
    accountDetailsValue: '1122334455',
    bankIdentifierType: 'BIC',
    bankIdentifierValue: 'CENAIDJA',
    fullName: 'FIRA DIYANKA',
  },
  {
    type: 'PERSONAL',
    countryCode: 'IN',
    accountDetailsType: 'ACCOUNT_ID',
    accountDetailsValue: '123456789007',
    bankIdentifierType: 'CLEARING_ID',
    bankIdentifierValue: 'ALLA0211480',
    fullName: 'DUMMY BENEFICIARY NAME',
  },
  {
    type: 'BUSINESS',
    countryCode: 'IN',
    accountDetailsType: 'ACCOUNT_ID',
    accountDetailsValue: '987654321002',
    bankIdentifierType: 'CLEARING_ID',
    bankIdentifierValue: 'YESB0000002',
    fullName: 'NATIONAL CRICKET CLUB',
  },
];

const internationalSampleCsvFile = {
  fileName: 'international-verification-bulk-upload.csv',
  sampleCsvData: internationalSampleCsvData,
};

export { internationalSampleCsvFile };
